
import ColorThemeController from './controllers/color-theme-controller';
import Navigation from './navigation/script';
import ContactForm from './forms/contact-form/script';
import HomeHero from './heroes/home/script';
import Parallax from './parallax/script';

import CategorySwitcher from './category-switcher/script';

import PlaneIllustration from './illustrations/illustration-airplane/script';

new ColorThemeController;
new Navigation;
new ContactForm;
new HomeHero;
new Parallax;
new CategorySwitcher;

new PlaneIllustration;